export default __webpack_public_path__ + "96e751967fc4f3d1988e8fca4a48d3ce.png";